import { useEffect, useState } from "react";
import { api, type ManagedUser, type UserRole } from "../lib/api";
import { AppSelect } from "./AppSelect";
import { UserAvatar } from "./UserAvatar";

const roleLabels: Record<UserRole, string> = { admin: "Amministratore", user: "Utente", blocked: "Disattivato" };

export function UsersPanel({ currentSub }: { currentSub: string }) {
  const [users, setUsers] = useState<ManagedUser[]>();
  const [message, setMessage] = useState<string>();
  const [busy, setBusy] = useState<string>();

  useEffect(() => { api.adminUsers().then((result) => setUsers(result.users)).catch((cause) => setMessage(cause instanceof Error ? cause.message : "Elenco utenti non disponibile")); }, []);

  async function change(user: ManagedUser, role: UserRole) {
    setBusy(user.sub); setMessage(undefined);
    try { setUsers((await api.setUserRole(user.sub, role)).users); }
    catch (cause) { setMessage(cause instanceof Error ? cause.message : "Modifica non riuscita"); }
    finally { setBusy(undefined); }
  }

  return <div className="panel-content settings-panel">
    <div className="section-heading"><span className="eyebrow">Amministrazione</span><h1>Utenti</h1><p>Chi ha effettuato l’accesso con Migliore Security. Il primo accesso è amministratore; i nuovi utenti entrano come utenti.</p></div>
    {message && <p className="settings-message">{message}</p>}
    {!users && !message && <div className="address-searching"><span className="spinner" />Carico gli utenti…</div>}
    <div className="users-list">
      {users?.map((user) => <section className="settings-card users-row" key={user.sub}>
        <UserAvatar name={user.name} picture={user.picture || undefined} />
        <div><strong>{user.name}{user.sub === currentSub && " (tu)"}</strong><small>{user.email || "—"} · ultimo accesso {new Date(user.lastSeenAt).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" })}</small></div>
        <div className="users-role"><AppSelect label={`Ruolo di ${user.name}`} value={user.role} searchable={false} disabled={user.sub === currentSub || busy === user.sub} options={(Object.keys(roleLabels) as UserRole[]).map((role) => ({ value: role, label: roleLabels[role] }))} onChange={(role) => void change(user, role as UserRole)} /></div>
      </section>)}
    </div>
  </div>;
}
